import ApiService from './api-service'

class Notifications extends ApiService {
    constructor() {
        super()

        this.get = null
        // this.post = null
        this.put = null
        // this.delete = null
    }

    register(payload = {}, options = {}) {
      return super.post(`notifications/register`, payload, options)
    }

    deregister(payload = {}) {
      return super.post(`notifications/deregister`, payload, {bypassInterceptor: true})
    }

    list(options) {
      return super.get(`v2/notification`, options)
    }

    get(id, options) {
      return super.get(`notification/${id}`, options)
    }

    acknowledge(id, options) {
      return super.post(`notification/${id}/acknowledge`, {}, options)
    }

    acknowledgeAll(options) {
      return super.post(`notification/acknowledge`, {}, options)
    }

    delete(id, options) {
      return super.delete(`notification/${id}`, options)
    }

    deleteAll(id, options) {
      return super.delete(`notification`, options)
    }

    clear() {
      return super.clear('/notification')
    }

    getStats(options) {
      return super.get(`notification/stats`, options)
    }
}

const _Notifications = new Notifications()
export default _Notifications
